import React, { useEffect, useRef } from "react";

import { MESSAGE_TYPE } from "../../constants/constant";

const MessageView = (props) => {
  const { receivedItem, userData, index } = props;

  const checkItemType = () => {
    return MESSAGE_TYPE.WEB_USER !== receivedItem?.participantType;
  };

  const AlwaysScrollToBottom = () => {
    const elementRef = useRef();
    useEffect(() => elementRef.current.scrollIntoView());
    return <div ref={elementRef} />;
  };

  return (
    <>
      <li
        key={index}
        className={`clearfix ${checkItemType() ? "dha-message" : "my-message"}`}
      >
        <div
          className={`message-data d-flex justify-content-between ${
            !checkItemType() && "flex-row-reverse"
          }`}
        >
          <span className="message-data-date">
            {!checkItemType()
              ? userData?.fullName
              : MESSAGE_TYPE.SYSTEM === receivedItem.participantType
              ? ""
              : receivedItem?.name}
          </span>
          <span className="message-data-time">{receivedItem?.time}</span>
        </div>
        <div
          className={`message ${
            checkItemType() ? "float-left " : "float-right"
          }`}
        >
          <p>{receivedItem?.value}</p>
        </div>
      </li>
      <AlwaysScrollToBottom />
    </>
  );
};

export default MessageView;
